import { useLang } from "@/i18n";
import { WHATSAPP } from "@/lib/site";
import { ArrowUpRight } from "lucide-react";
import { Num, Reveal, SectionHead } from "./Primitives";

export const Dosh = () => {
  const { t } = useLang();
  return (
    <section id="dosh" data-testid="dosh-section" className="mx-auto max-w-[1440px] px-5 sm:px-8 py-24 lg:py-36">
      <SectionHead eyebrow={t.dosh.eyebrow} title={t.dosh.title} desc={t.dosh.desc} testid="dosh" align="right" />
      <div className="mt-16 grid grid-cols-1 md:grid-cols-6 gap-5">
        {t.dosh.items.map((d, i) => (
          <Reveal key={i} delay={i * 0.08} className={i < 2 ? "md:col-span-3" : "md:col-span-2"}>
            <a href={WHATSAPP} target="_blank" rel="noreferrer" data-testid={`dosh-item-${i}`}
              className="card group h-full flex flex-col justify-between p-8 min-h-[260px]">
              <div className="flex items-center justify-between">
                <Num n={i + 1} />
                <ArrowUpRight className="w-5 h-5 text-[color:var(--gold)] transition-transform duration-500 group-hover:rotate-45" />
              </div>
              <div className="mt-10">
                <h3 className="display text-3xl">{d.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[color:var(--muted)]">{d.text}</p>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
